export default __webpack_public_path__ + "static/media/loading.96228823.svg";